import { formatMessage } from '@99designs/common/i18n';
import { TabularMeta_User } from '__generated__/TabularMeta_User';
import { handlePromise } from 'common/utils/Bugsnag';
import { MAX_DESIGNERS } from 'projects/consts';
import { trackRemovedDesignerEvent } from 'projects/events';
import RemoveStructuredBriefDesigners from 'projects/mutations/RemoveStructuredBriefDesigners';
import * as React from 'react';
import DesignerConfirmationModal from './DesignerConfirmationModal';
import DesignerSelection from './DesignerSelection';
import LaunchModal, { LaunchState } from './LaunchModal';
import StepFooter, { Props as StepFooterProps } from './StepFooter';

export interface Props {
    stepFooterProps: StepFooterProps;
    launchState?: LaunchState;
    brief: {
        id: string;
        designers: TabularMeta_User[];
        contacts: TabularMeta_User[];
        projectIds: number[];
    };
    saving: boolean;
}

interface State {
    showConfirmationModal: boolean;
}

class BriefFooter extends React.Component<Props, State> {
    state = {
        showConfirmationModal: false,
    };

    UNSAFE_componentWillReceiveProps(props: Props) {
        if (props.brief.designers.length === 0) {
            this.setState({ showConfirmationModal: false });
        }
    }

    renderDesignerSelection = (isDesignerStep: boolean = false) => (
        <RemoveStructuredBriefDesigners>
            {removeDesigners => (
                <DesignerSelection
                    brief={this.props.brief}
                    showTooltips={isDesignerStep}
                    designers={this.props.brief.designers}
                    isDesignerStep={isDesignerStep}
                    onRemoveDesigner={id => {
                        trackRemovedDesignerEvent({
                            id: this.props.brief.id,
                            designer_id: id,
                        });
                        handlePromise(
                            removeDesigners({
                                id: this.props.brief.id,
                                designerIds: [id],
                            }),
                            'BriefFooter RemoveDesigners'
                        );
                    }}
                    selectDesignersCopy={{
                        heading: __('Your designer shortlist'),
                        message: formatMessage(
                            __(
                                'When ready, request quote(s) from your chosen designers. You can choose between 1 & {maxDesigners}.'
                            ),
                            {
                                maxDesigners: MAX_DESIGNERS,
                            }
                        ),
                        storageKey: 'designer_selection_designer_placeholder_tooltip',
                    }}
                    confirmDesignersCopy={{
                        heading: __('You’re done!'),
                        message: __(
                            'Simply confirm your chosen designers to request quote(s) and get underway.'
                        ),
                        storageKey: 'designer_selection_max_designers_tooltip',
                    }}
                />
            )}
        </RemoveStructuredBriefDesigners>
    );

    render() {
        const { stepFooterProps, launchState, brief, saving } = this.props;
        const { showConfirmationModal } = this.state;
        const isDesignerStep = stepFooterProps.step.isDesignerStep();
        if (isDesignerStep) {
            stepFooterProps.nextAction = () => this.setState({ showConfirmationModal: true });
            stepFooterProps.disabled = brief.designers.length == 0;
        }

        return (
            <>
                <StepFooter {...stepFooterProps}>
                    {this.renderDesignerSelection(isDesignerStep)}
                </StepFooter>
                {launchState && (
                    <LaunchModal state={launchState} brief={brief} showing={!!launchState} />
                )}
                <DesignerConfirmationModal
                    brief={brief}
                    onConfirm={stepFooterProps.launchAction}
                    saving={saving}
                    onDismiss={() => this.setState({ showConfirmationModal: false })}
                    showing={showConfirmationModal}
                />
            </>
        );
    }
}

export default BriefFooter;
